import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { HotkeysService } from 'src/app/_services/hotkeys.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CreateHotkeyComponent } from './create-hotkey/create-hotkey.component';
import { UpdateHotkeyComponent } from './update-hotkey/update-hotkey.component';
import { CreateTagDialogComponent } from './create-tag-dialog/create-tag-dialog.component';
import { UpdateTagDialogComponent } from './update-tag-dialog/update-tag-dialog.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-hotkeys',
  templateUrl: './hotkeys.component.html',
  styleUrls: ['./hotkeys.component.scss'],
})
export class HotkeysComponent implements OnInit {
  hotkeys: any = [];
  ref: any;
  selectedKey: any;
  hotkey: any;
  hotkey$ = this.hotkeysService.hotkeys$;
  loadingHotkey$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  activeIssuesTransformed: any[] = [];
  @ViewChild('dt') dt: Table | undefined;
  searchValue = '';

  columns = [
    { field: 'hotkey_main', header: 'Main Hotkey' },
    { field: 'main_description', header: 'Main description' },
    { field: 'hotkey_tag', header: 'Hotkey Tag' },
  ];

  items: MenuItem[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.updateHotkey(this.selectedKey),
    },
    {
      label: 'Delete Hotkey',
      icon: 'pi pi-trash',
      command: () => this.deleteHotkey(this.selectedKey),
    },
    {
      label: 'Add Tag',
      icon: 'pi pi-plus',
      command: () => this.showCreateTagDialog(this.selectedKey),
    }
  ];

  constructor(
    private hotkeysService: HotkeysService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.hotkeysService.getHotkeys().subscribe((data) => {
      this.hotkeysService.updateHotkeys(data);
    });
    setTimeout(() => {
      this.loadingHotkey$.next(false);
    }, 1000);
  }

  filterGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchValue = inputElement.value;
    this.dt?.filterGlobal(this.searchValue, 'contains');
  }

  clearSearch() {
    this.searchValue = '';
    this.dt?.clear();
  }

  showCreateTagDialog(hotkey: any) {
    this.ref = this.dialogService.open(CreateTagDialogComponent, {
      header: 'Create Tag',
      width: '70%',
      styleClass: 'update-record-dialog-shell',
      data: hotkey,
      closeOnEscape: true,
    });
  }

  showUpdateTagDialog(tag: any) {
    this.ref = this.dialogService.open(UpdateTagDialogComponent, {
      header: 'Update Tag',
      width: '75%',
      styleClass: 'update-record-dialog-shell',
      data: tag,
      closeOnEscape: true,
    });
  }

  showCreateHotkeyDialog() {
    this.ref = this.dialogService.open(CreateHotkeyComponent, {
      header: 'Create Hotkey',
      width: '75%',
      styleClass: 'update-record-dialog-shell',
      closeOnEscape: true,
    });
  }

  updateHotkey(hotkey: any) {
    this.ref = this.dialogService.open(UpdateHotkeyComponent, {
      header: 'Update Hotkey',
      width: '75%',
      styleClass: 'update-record-dialog-shell',
      closeOnEscape: true,
      data: {
        hotkey: hotkey,
      },
    });
  }

  deleteTag(tag: any){
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this tag?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.hotkeysService.deleteHotkey(tag.id).subscribe(
          (data) => {
            this.hotkeysService.getHotkeys().subscribe((data) => {
              this.hotkeysService.updateHotkeys(data);
            });
          },
          (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'An error occurred while deleting the tag',
              key: 'hotkeys',
            });
          },
          () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Tag deleted successfully',
              key: 'hotkeys',
            });
          }
        );
      },
    });
  }

  deleteHotkey(hotkey: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this hotkey? This will also delete all associated tags',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const deletions = hotkey.descriptions.map((tag: any) =>
          this.hotkeysService.deleteHotkey(tag.id)
        );

        forkJoin(deletions).subscribe({
          next: () => {
            this.hotkeysService.getHotkeys().subscribe((data) => {
              this.hotkeysService.updateHotkeys(data);
            });
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Hotkey deleted successfully',
              key: 'hotkeys',
            });
          },
          error: () => {
            this.hotkeysService.getHotkeys().subscribe((data) => {
              this.hotkeysService.updateHotkeys(data);
            });
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete one or more tags for this hotkey',
              key: 'hotkeys',
            });
          },
        });
      },
    });
  }

  storeRowDetail(rowData: any) {
    this.selectedKey = rowData;
  }


}
